package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Niue Flag (32x24dp)
 *
 * - ISO Alpha-2: NU
 * - ISO Alpha-3: NIU
 * - ISO Numeric: 570
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Niue: ImageVector by lazy {
    ImageVector.Builder(
        name = "Niue:NU:NIU:570:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 16f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(-2.262f, 15.129f)
                lineTo(4.081f, 16.597f)
                lineTo(17.602f, 9.126f)
                lineTo(19.032f, 8.289f)
                lineTo(31.876f, 1.573f)
                lineTo(34.919f, -0.548f)
                lineTo(27.959f, -1.189f)
                lineTo(16.737f, 5.141f)
                lineTo(8.628f, 9.126f)
                lineTo(-2.262f, 15.129f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.705f, 16.019f)
                lineTo(1.71f, 17.139f)
                lineTo(33.649f, -0.814f)
                horizontalLineTo(28.854f)
                lineTo(-1.705f, 16.019f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(34.371f, 14.731f)
                lineTo(34.623f, 16.241f)
                lineTo(27.919f, 16.597f)
                lineTo(17.113f, 10.267f)
                lineTo(16.094f, 10.615f)
                lineTo(-4.08f, 0.411f)
                lineTo(4.249f, -1.193f)
                lineTo(15.385f, 4.959f)
                lineTo(24.097f, 9.168f)
                lineTo(34.371f, 14.731f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(34.394f, 15.637f)
                lineTo(30.979f, 16.757f)
                lineTo(17.379f, 9.071f)
                lineTo(13.347f, 8.212f)
                lineTo(-3.259f, -0.538f)
                horizontalLineTo(1.536f)
                lineTo(18.132f, 8.004f)
                lineTo(22.541f, 9.034f)
                lineTo(34.394f, 15.637f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(13.189f, -1.25f)
                verticalLineTo(-2.5f)
                horizontalLineTo(11.939f)
                verticalLineTo(-1.25f)
                horizontalLineTo(13.189f)
                close()
                moveTo(13.189f, 4.75f)
                verticalLineTo(6f)
                horizontalLineTo(14.439f)
                verticalLineTo(4.75f)
                horizontalLineTo(13.189f)
                close()
                moveTo(-1.25f, 4.75f)
                verticalLineTo(3.5f)
                horizontalLineTo(-2.5f)
                verticalLineTo(4.75f)
                horizontalLineTo(-1.25f)
                close()
                moveTo(-1.25f, 11.25f)
                horizontalLineTo(-2.5f)
                verticalLineTo(12.5f)
                horizontalLineTo(-1.25f)
                verticalLineTo(11.25f)
                close()
                moveTo(13.189f, 11.25f)
                horizontalLineTo(14.439f)
                verticalLineTo(10f)
                horizontalLineTo(13.189f)
                verticalLineTo(11.25f)
                close()
                moveTo(13.189f, 19.25f)
                horizontalLineTo(11.939f)
                verticalLineTo(20.5f)
                horizontalLineTo(13.189f)
                verticalLineTo(19.25f)
                close()
                moveTo(18.878f, 19.25f)
                verticalLineTo(20.5f)
                horizontalLineTo(20.128f)
                verticalLineTo(19.25f)
                horizontalLineTo(18.878f)
                close()
                moveTo(18.878f, 11.25f)
                verticalLineTo(10f)
                horizontalLineTo(17.628f)
                verticalLineTo(11.25f)
                horizontalLineTo(18.878f)
                close()
                moveTo(33.25f, 11.25f)
                verticalLineTo(12.5f)
                horizontalLineTo(34.5f)
                verticalLineTo(11.25f)
                horizontalLineTo(33.25f)
                close()
                moveTo(33.25f, 4.75f)
                horizontalLineTo(34.5f)
                verticalLineTo(3.5f)
                horizontalLineTo(33.25f)
                verticalLineTo(4.75f)
                close()
                moveTo(18.878f, 4.75f)
                horizontalLineTo(17.628f)
                verticalLineTo(6f)
                horizontalLineTo(18.878f)
                verticalLineTo(4.75f)
                close()
                moveTo(18.878f, -1.25f)
                horizontalLineTo(20.128f)
                verticalLineTo(-2.5f)
                horizontalLineTo(18.878f)
                verticalLineTo(-1.25f)
                close()
                moveTo(16.378f, 4.75f)
                verticalLineTo(6f)
                horizontalLineTo(17.628f)
                verticalLineTo(4.75f)
                horizontalLineTo(16.378f)
                close()
                moveTo(16.378f, 1.25f)
                horizontalLineTo(17.628f)
                verticalLineTo(0f)
                horizontalLineTo(16.378f)
                verticalLineTo(1.25f)
                close()
                moveTo(15.689f, 1.25f)
                verticalLineTo(0f)
                horizontalLineTo(14.439f)
                verticalLineTo(1.25f)
                horizontalLineTo(15.689f)
                close()
                moveTo(15.689f, 4.75f)
                horizontalLineTo(14.439f)
                verticalLineTo(6f)
                horizontalLineTo(15.689f)
                verticalLineTo(4.75f)
                close()
                moveTo(16.378f, 7.25f)
                horizontalLineTo(17.628f)
                verticalLineTo(6f)
                horizontalLineTo(16.378f)
                verticalLineTo(7.25f)
                close()
                moveTo(15.689f, 7.25f)
                verticalLineTo(6f)
                horizontalLineTo(14.439f)
                verticalLineTo(7.25f)
                horizontalLineTo(15.689f)
                close()
                moveTo(16.378f, 8.75f)
                verticalLineTo(10f)
                horizontalLineTo(17.628f)
                verticalLineTo(8.75f)
                horizontalLineTo(16.378f)
                close()
                moveTo(15.689f, 8.75f)
                horizontalLineTo(14.439f)
                verticalLineTo(10f)
                horizontalLineTo(15.689f)
                verticalLineTo(8.75f)
                close()
                moveTo(13.189f, 7.25f)
                horizontalLineTo(14.439f)
                verticalLineTo(6f)
                horizontalLineTo(13.189f)
                verticalLineTo(7.25f)
                close()
                moveTo(1.25f, 7.25f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(7.25f)
                horizontalLineTo(1.25f)
                close()
                moveTo(1.25f, 8.75f)
                horizontalLineTo(0f)
                verticalLineTo(10f)
                horizontalLineTo(1.25f)
                verticalLineTo(8.75f)
                close()
                moveTo(13.189f, 8.75f)
                verticalLineTo(10f)
                horizontalLineTo(14.439f)
                verticalLineTo(8.75f)
                horizontalLineTo(13.189f)
                close()
                moveTo(15.689f, 11.25f)
                verticalLineTo(10f)
                horizontalLineTo(14.439f)
                verticalLineTo(11.25f)
                horizontalLineTo(15.689f)
                close()
                moveTo(15.689f, 16.75f)
                horizontalLineTo(14.439f)
                verticalLineTo(18f)
                horizontalLineTo(15.689f)
                verticalLineTo(16.75f)
                close()
                moveTo(16.378f, 16.75f)
                verticalLineTo(18f)
                horizontalLineTo(17.628f)
                verticalLineTo(16.75f)
                horizontalLineTo(16.378f)
                close()
                moveTo(16.378f, 11.25f)
                horizontalLineTo(17.628f)
                verticalLineTo(10f)
                horizontalLineTo(16.378f)
                verticalLineTo(11.25f)
                close()
                moveTo(18.878f, 7.25f)
                verticalLineTo(6f)
                horizontalLineTo(17.628f)
                verticalLineTo(7.25f)
                horizontalLineTo(18.878f)
                close()
                moveTo(18.878f, 8.75f)
                horizontalLineTo(17.628f)
                verticalLineTo(10f)
                horizontalLineTo(18.878f)
                verticalLineTo(8.75f)
                close()
                moveTo(30.75f, 7.25f)
                horizontalLineTo(32f)
                verticalLineTo(6f)
                horizontalLineTo(30.75f)
                verticalLineTo(7.25f)
                close()
                moveTo(30.75f, 8.75f)
                verticalLineTo(10f)
                horizontalLineTo(32f)
                verticalLineTo(8.75f)
                horizontalLineTo(30.75f)
                close()
                moveTo(13.189f, 0f)
                horizontalLineTo(14.439f)
                verticalLineTo(-2.5f)
                horizontalLineTo(13.189f)
                verticalLineTo(0f)
                close()
                moveTo(14.439f, 0f)
                verticalLineTo(-1.25f)
                horizontalLineTo(11.939f)
                verticalLineTo(0f)
                horizontalLineTo(14.439f)
                close()
                moveTo(14.439f, 4.75f)
                verticalLineTo(0f)
                horizontalLineTo(11.939f)
                verticalLineTo(4.75f)
                horizontalLineTo(14.439f)
                close()
                moveTo(0f, 6f)
                horizontalLineTo(13.189f)
                verticalLineTo(3.5f)
                horizontalLineTo(0f)
                verticalLineTo(6f)
                close()
                moveTo(-1.25f, 6f)
                horizontalLineTo(0f)
                verticalLineTo(3.5f)
                horizontalLineTo(-1.25f)
                verticalLineTo(6f)
                close()
                moveTo(0f, 6f)
                verticalLineTo(4.75f)
                horizontalLineTo(-2.5f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 10f)
                verticalLineTo(6f)
                horizontalLineTo(-2.5f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 11.25f)
                verticalLineTo(10f)
                horizontalLineTo(-2.5f)
                verticalLineTo(11.25f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 10f)
                horizontalLineTo(-1.25f)
                verticalLineTo(12.5f)
                horizontalLineTo(0f)
                verticalLineTo(10f)
                close()
                moveTo(13.189f, 10f)
                horizontalLineTo(0f)
                verticalLineTo(12.5f)
                horizontalLineTo(13.189f)
                verticalLineTo(10f)
                close()
                moveTo(14.439f, 18f)
                verticalLineTo(11.25f)
                horizontalLineTo(11.939f)
                verticalLineTo(18f)
                horizontalLineTo(14.439f)
                close()
                moveTo(14.439f, 19.25f)
                verticalLineTo(18f)
                horizontalLineTo(11.939f)
                verticalLineTo(19.25f)
                horizontalLineTo(14.439f)
                close()
                moveTo(14.439f, 18f)
                horizontalLineTo(13.189f)
                verticalLineTo(20.5f)
                horizontalLineTo(14.439f)
                verticalLineTo(18f)
                close()
                moveTo(17.628f, 18f)
                horizontalLineTo(14.439f)
                verticalLineTo(20.5f)
                horizontalLineTo(17.628f)
                verticalLineTo(18f)
                close()
                moveTo(18.878f, 18f)
                horizontalLineTo(17.628f)
                verticalLineTo(20.5f)
                horizontalLineTo(18.878f)
                verticalLineTo(18f)
                close()
                moveTo(17.628f, 18f)
                verticalLineTo(19.25f)
                horizontalLineTo(20.128f)
                verticalLineTo(18f)
                horizontalLineTo(17.628f)
                close()
                moveTo(17.628f, 11.25f)
                verticalLineTo(18f)
                horizontalLineTo(20.128f)
                verticalLineTo(11.25f)
                horizontalLineTo(17.628f)
                close()
                moveTo(32f, 10f)
                horizontalLineTo(18.878f)
                verticalLineTo(12.5f)
                horizontalLineTo(32f)
                verticalLineTo(10f)
                close()
                moveTo(33.25f, 10f)
                horizontalLineTo(32f)
                verticalLineTo(12.5f)
                horizontalLineTo(33.25f)
                verticalLineTo(10f)
                close()
                moveTo(32f, 10f)
                verticalLineTo(11.25f)
                horizontalLineTo(34.5f)
                verticalLineTo(10f)
                horizontalLineTo(32f)
                close()
                moveTo(32f, 6f)
                verticalLineTo(10f)
                horizontalLineTo(34.5f)
                verticalLineTo(6f)
                horizontalLineTo(32f)
                close()
                moveTo(32f, 4.75f)
                verticalLineTo(6f)
                horizontalLineTo(34.5f)
                verticalLineTo(4.75f)
                horizontalLineTo(32f)
                close()
                moveTo(32f, 6f)
                horizontalLineTo(33.25f)
                verticalLineTo(3.5f)
                horizontalLineTo(32f)
                verticalLineTo(6f)
                close()
                moveTo(18.878f, 6f)
                horizontalLineTo(32f)
                verticalLineTo(3.5f)
                horizontalLineTo(18.878f)
                verticalLineTo(6f)
                close()
                moveTo(17.628f, 0f)
                verticalLineTo(4.75f)
                horizontalLineTo(20.128f)
                verticalLineTo(0f)
                horizontalLineTo(17.628f)
                close()
                moveTo(17.628f, -1.25f)
                verticalLineTo(0f)
                horizontalLineTo(20.128f)
                verticalLineTo(-1.25f)
                horizontalLineTo(17.628f)
                close()
                moveTo(17.628f, 0f)
                horizontalLineTo(18.878f)
                verticalLineTo(-2.5f)
                horizontalLineTo(17.628f)
                verticalLineTo(0f)
                close()
                moveTo(14.439f, 0f)
                horizontalLineTo(17.628f)
                verticalLineTo(-2.5f)
                horizontalLineTo(14.439f)
                verticalLineTo(0f)
                close()
                moveTo(17.628f, 4.75f)
                verticalLineTo(1.25f)
                horizontalLineTo(15.127f)
                verticalLineTo(4.75f)
                horizontalLineTo(17.628f)
                close()
                moveTo(16.378f, 0f)
                horizontalLineTo(15.689f)
                verticalLineTo(2.5f)
                horizontalLineTo(16.378f)
                verticalLineTo(0f)
                close()
                moveTo(14.439f, 1.25f)
                verticalLineTo(4.75f)
                horizontalLineTo(16.939f)
                verticalLineTo(1.25f)
                horizontalLineTo(14.439f)
                close()
                moveTo(15.689f, 6f)
                horizontalLineTo(16.378f)
                verticalLineTo(3.5f)
                horizontalLineTo(15.689f)
                verticalLineTo(6f)
                close()
                moveTo(16.378f, 6f)
                horizontalLineTo(15.689f)
                verticalLineTo(8.5f)
                horizontalLineTo(16.378f)
                verticalLineTo(6f)
                close()
                moveTo(17.628f, 8.75f)
                verticalLineTo(7.25f)
                horizontalLineTo(15.127f)
                verticalLineTo(8.75f)
                horizontalLineTo(17.628f)
                close()
                moveTo(15.689f, 10f)
                horizontalLineTo(16.378f)
                verticalLineTo(7.5f)
                horizontalLineTo(15.689f)
                verticalLineTo(10f)
                close()
                moveTo(14.439f, 7.25f)
                verticalLineTo(8.75f)
                horizontalLineTo(16.939f)
                verticalLineTo(7.25f)
                horizontalLineTo(14.439f)
                close()
                moveTo(13.189f, 6f)
                horizontalLineTo(1.25f)
                verticalLineTo(8.5f)
                horizontalLineTo(13.189f)
                verticalLineTo(6f)
                close()
                moveTo(0f, 7.25f)
                verticalLineTo(8.75f)
                horizontalLineTo(2.5f)
                verticalLineTo(7.25f)
                horizontalLineTo(0f)
                close()
                moveTo(1.25f, 10f)
                horizontalLineTo(13.189f)
                verticalLineTo(7.5f)
                horizontalLineTo(1.25f)
                verticalLineTo(10f)
                close()
                moveTo(14.439f, 8.75f)
                verticalLineTo(7.25f)
                horizontalLineTo(11.939f)
                verticalLineTo(8.75f)
                horizontalLineTo(14.439f)
                close()
                moveTo(14.439f, 11.25f)
                verticalLineTo(16.75f)
                horizontalLineTo(16.939f)
                verticalLineTo(11.25f)
                horizontalLineTo(14.439f)
                close()
                moveTo(15.689f, 18f)
                horizontalLineTo(16.378f)
                verticalLineTo(15.5f)
                horizontalLineTo(15.689f)
                verticalLineTo(18f)
                close()
                moveTo(17.628f, 16.75f)
                verticalLineTo(11.25f)
                horizontalLineTo(15.127f)
                verticalLineTo(16.75f)
                horizontalLineTo(17.628f)
                close()
                moveTo(16.378f, 10f)
                horizontalLineTo(15.689f)
                verticalLineTo(12.5f)
                horizontalLineTo(16.378f)
                verticalLineTo(10f)
                close()
                moveTo(17.628f, 7.25f)
                verticalLineTo(8.75f)
                horizontalLineTo(20.128f)
                verticalLineTo(7.25f)
                horizontalLineTo(17.628f)
                close()
                moveTo(30.75f, 6f)
                horizontalLineTo(18.878f)
                verticalLineTo(8.5f)
                horizontalLineTo(30.75f)
                verticalLineTo(6f)
                close()
                moveTo(32f, 8.75f)
                verticalLineTo(7.25f)
                horizontalLineTo(29.5f)
                verticalLineTo(8.75f)
                horizontalLineTo(32f)
                close()
                moveTo(18.878f, 10f)
                horizontalLineTo(30.75f)
                verticalLineTo(7.5f)
                horizontalLineTo(18.878f)
                verticalLineTo(10f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.692f, -1.333f)
                horizontalLineTo(14.308f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(10f)
                horizontalLineTo(14.308f)
                verticalLineTo(19.333f)
                horizontalLineTo(17.692f)
                verticalLineTo(10f)
                horizontalLineTo(34f)
                verticalLineTo(6f)
                horizontalLineTo(17.692f)
                verticalLineTo(-1.333f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.05f, 10.6f)
                curveTo(17.569f, 10.6f, 18.8f, 9.369f, 18.8f, 7.85f)
                curveTo(18.8f, 6.331f, 17.569f, 5.1f, 16.05f, 5.1f)
                curveTo(14.531f, 5.1f, 13.3f, 6.331f, 13.3f, 7.85f)
                curveTo(13.3f, 9.369f, 14.531f, 10.6f, 16.05f, 10.6f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.1f, 8.691f)
                lineTo(14.802f, 9.594f)
                lineTo(15.26f, 8.081f)
                lineTo(14f, 7.126f)
                lineTo(15.581f, 7.094f)
                lineTo(16.1f, 5.6f)
                lineTo(16.619f, 7.094f)
                lineTo(18.2f, 7.126f)
                lineTo(16.94f, 8.081f)
                lineTo(17.398f, 9.594f)
                lineTo(16.1f, 8.691f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.1f, 8.576f)
                lineTo(6.018f, 9.329f)
                lineTo(6.4f, 8.068f)
                lineTo(5.35f, 7.271f)
                lineTo(6.667f, 7.245f)
                lineTo(7.1f, 6f)
                lineTo(7.533f, 7.245f)
                lineTo(8.85f, 7.271f)
                lineTo(7.8f, 8.068f)
                lineTo(8.182f, 9.329f)
                lineTo(7.1f, 8.576f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(25.1f, 8.576f)
                lineTo(24.018f, 9.329f)
                lineTo(24.4f, 8.068f)
                lineTo(23.35f, 7.271f)
                lineTo(24.667f, 7.245f)
                lineTo(25.1f, 6f)
                lineTo(25.533f, 7.245f)
                lineTo(26.85f, 7.271f)
                lineTo(25.8f, 8.068f)
                lineTo(26.181f, 9.329f)
                lineTo(25.1f, 8.576f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.1f, 3.776f)
                lineTo(15.018f, 4.529f)
                lineTo(15.4f, 3.268f)
                lineTo(14.35f, 2.471f)
                lineTo(15.667f, 2.445f)
                lineTo(16.1f, 1.2f)
                lineTo(16.533f, 2.445f)
                lineTo(17.85f, 2.471f)
                lineTo(16.8f, 3.268f)
                lineTo(17.181f, 4.529f)
                lineTo(16.1f, 3.776f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.1f, 14.376f)
                lineTo(15.018f, 15.129f)
                lineTo(15.4f, 13.868f)
                lineTo(14.35f, 13.071f)
                lineTo(15.667f, 13.045f)
                lineTo(16.1f, 11.8f)
                lineTo(16.533f, 13.045f)
                lineTo(17.85f, 13.071f)
                lineTo(16.8f, 13.868f)
                lineTo(17.181f, 15.129f)
                lineTo(16.1f, 14.376f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NiuePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Niue,
            contentDescription = "Niue Flag"
        )
    }
}
